module.exports = __webpack_public_path__ + "static/media/AutoFitWidth.cc56f341.svg";